import styled from 'styled-components';
import { Form, Input, Checkbox, Button, Alert } from 'antd';

export const LoginFormWrapper = styled.div`
  margin-top: 40px;
  margin-left: 50px;

  img {
    width: 190px;
    height: 172px;
  }
`;

export const LoginForm = styled(Form)`
  width: 450px;
  margin-left: 25px;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
`;

export const FormItem = styled(Form.Item)`
  width: 100%;

  label {
    color: rgba(15, 35, 250, 1);
    font-size: 20px;
    font-weight: 700;
  }
`;

export const FormInput = styled(Input)`
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #000;
  box-shadow: none !important;
  height: 38px;
  font-size: 20px;
  margin-left: 0;
  padding-left: 0;
`;

export const FormInputPassword = styled(Input.Password)`
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #000;
  box-shadow: none !important;
  height: 38px;
  font-size: 20px;
  margin-left: 0;
  padding-left: 0;
  .ant-input {
    font-size: 20px;
  }
`;

export const SubmitButtom = styled(Button)`
  font-size: 17px;
  line-height: 24px;
  background: #0f23fa;
  width: 202px;
  height: 66px;
  color: #fff;
  margin-top: 20px;
  padding-top: 5px;
  &:hover {
    background: rgba(15, 35, 250, 0.3) !important;
    color: #fff;
  }

  .anticon {
    vertical-align: 0em;
  }
`;

export const Description = styled.div`
  color: #727272;
  margin: 10px 60px 0 25px;
  font-size: 9px;
  line-height: 11px;
`;

export const ErrorAlert = styled(Alert)`
  border: 0px;
  background-color: transparent;
  color: #f81d22;
  padding: 0;
  margin-left: 0;
  .ant-alert-message {
    color: #f81d22;
  }
`;
